import { render, staticRenderFns } from "./water-mask.vue?vue&type=template&id=16d9ca46&scoped=true&"
import script from "./water-mask.vue?vue&type=script&lang=js&"
export * from "./water-mask.vue?vue&type=script&lang=js&"
import style0 from "./water-mask.vue?vue&type=style&index=0&id=16d9ca46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d9ca46",
  null
  
)

export default component.exports